<template>
  <!-- <div :style="{ backgroundImage: `url(${backgroundUrl})` }"> -->
  <div class="bg" id="messageBody">
    <div>
      <p class="text">กรุณาเลือกภูมิภาค</p>
      <!-- ราศรี : {{ $store.state.form.zodiac }} ภาค :
      {{ $store.state.form.location }} -->
    </div>
    <div class="d-flex justify-content-around">
      <b-img src="../assets/select/N.png" @click="locationN" />
      <b-img src="../assets/select/C.png" @click="locationC" />
      <b-img src="../assets/select/I.png" @click="locationI" />
      <b-img src="../assets/select/S.png" @click="locationS" />
    </div>
    <div
      :style="{ backgroundImage: `url(${backgroundUrl})` }"
      class="bglocation"
    >
      <div class="img-container">
        <img :src="src" style="margin-top: 200px" />
      </div>
      <div>
        <!-- <b-img @click="subMitselect" src="../assets/btn-selectpray.png" /> -->
        <button
          class="base-btn mt-4"
          @click="subMitselect"
          v-if="formData.kathong_id"
        >
          อธิษฐานเลย!
        </button>
      </div>
      <div style="margin-top: 80px">
        <p class="text">กรุณาเลือกกระทง</p>
        <carousel>
          <slide v-for="kathong in kathongList" :key="kathong.kathong_id">
            <div class="img-container">
              <img
                :src="kathong.img"
                @click="select(kathong.kathong_id, kathong.img)"
              />
            </div>
          </slide>
          <!-- <slide>
            <b-img src="../assets/kathong2.png" @click="select"></b-img>
          </slide>
          <slide>
            <b-img src="../assets/kathong3.png" @click="select"></b-img>
          </slide>
          <slide>
            <b-img src="../assets/kathong4.png" @click="select"></b-img>
          </slide> -->
        </carousel>
      </div>
    </div>
  </div>
</template>

<script>
// import liff from "@line/liff";
import { Carousel, Slide } from "vue-carousel";
import axios from "axios";
import baseUrl from "../util/backend";
export default {
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {
      backgroundUrl: "https://vulcan.houseofdev.tech/img-kathong/bg4.gif",
      src: "https://i.ibb.co/02DwvM1/dfkathong.png",
      displayName: "",
      userId: "",
      pictureUrl: "",
      kathongList: [
        {
          url: "../assets/kathong1.png",
        },
        {
          url: "../assets/kathong2.png",
        },
        {
          url: "../assets/kathong3.png",
        },
        {
          url: "../assets/kathong4.png",
        },
      ],
    };
  },
  computed: {
    formData() {
      return this.$store.getters.getForm;
    },
  },
  methods: {
    //ภาคเหนือ
    locationN() {
      this.backgroundUrl = "https://vulcan.houseofdev.tech/img-kathong/bg4.gif";
      this.$store.dispatch("setFrom", {
        location: "north",
      });
      console.log(this.$store.state.form.location);
      console.log(this.$store.state.form.zodiac);
    },
    locationS() {
      //ภาคใต้
      this.backgroundUrl = "https://vulcan.houseofdev.tech/img-kathong/bg1.gif";
      this.$store.dispatch("setFrom", {
        location: "south",
      });
      console.log(this.$store.state.form.location);
      console.log(this.$store.state.form.zodiac);
    },
    locationI() {
      //ภาคอิสาน
      this.backgroundUrl = "https://vulcan.houseofdev.tech/img-kathong/bg3.gif";
      this.$store.dispatch("setFrom", {
        location: "northeast",
      });
      console.log(this.$store.state.form.location);
      console.log(this.$store.state.form.zodiac);
    },
    //ภาคกลาง
    locationC() {
      this.backgroundUrl = "https://vulcan.houseofdev.tech/img-kathong/bg2.gif";
      this.$store.dispatch("setFrom", {
        location: "central",
      });
      console.log(this.$store.state.form.location);
      console.log(this.$store.state.form.zodiac);
    },
    select(id, img) {
      this.src = img;
      this.$store.dispatch("setFrom", {
        kathong_id: id,
        srcimg: img,
      });
    },
    subMitselect() {
      // this.$store.dispatch("setFrom", {
      //   pictureUrl: this.pictureUrl,
      //   name: this.displayName,
      // });
      this.$router.push("/prayer");
    },
    async loadKrathongList() {
      const res = await axios.get(`${baseUrl}/getkathong`);
      console.log(res.data.data);
      this.kathongList = res.data.data;
    },
  },
  created() {
    this.loadKrathongList();
    
  },
  mounted() {
    // liff
    //   .init({
    //     liffId: "1655035523-EwGOXLaa",
    //   })
    //   .then(() => {
    //     if (liff.isLoggedIn()) {
    //       liff.getProfile().then((profile) => {
    //         this.userId = profile.userId;
    //         this.displayName = profile.displayName;
    //         this.pictureUrl = profile.pictureUrl;
    //         console.log(profile);
    //       });
    //     } else {
    //       liff.login();
    //     }
    //   });
    this.$store.dispatch("setFrom", {
      location: "north",
      // pictureUrl: this.pictureUrl,
      // name: this.displayName,
    });
    console.log(this.$store.state.form);
    var messageBody = document.querySelector("#messageBody");
    messageBody.scrollTop = 0;
  },
};
</script>

<style scoped>
.bg {
  /* background-image: url("../assets/BG.png");
  background-repeat: no-repeat;*/
  height: 100%;
  /* background-image: url("../assets/background.jpg"); */
  background-repeat: no-repeat;
  /* background-size: 450px; */
  background-size: cover;
  background-position: center;
  /* background-image: linear-gradient(#48087A, #1a96A8); */
}
.text {
  color: white;
  font-size: 25px;
}
.img-container {
  width: 150px;
  margin: 0 auto;
}

.img-container img {
  width: 100%;
}

.bglocation {
  /* height: 100vh; */
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  /* background-size: 100%; */
  /* width: 100%; */
}
</style>
